import React from 'react';
import styles from '@components/PageWrapper.module.css';

const PageWrapper = (props) => {
  return (
    <div
      className={styles.wrapper_style}
      style={{
        backgroundColor: props.backgroundColor ? props.backgroundColor : "",
        paddingTop: props.paddingTop ? props.paddingTop : ""
      }}
    >
      {props.children}
    </div>
  )
}

export default PageWrapper;
